export default __webpack_public_path__ + "2aa797be69497765ae8aded25d440b2d.png";